export const PENDING_ACTION_CATEGORIES = [
  {
    id: "all",
    label: "Todos os alertas",
    actionTypes: null,
  },
  {
    id: "remote_machine_finish",
    label: "Encerramento incompleto",
    actionTypes: ["remote_machine_finish"],
  },
  {
    id: "meter_reading_anomaly",
    label: "Leitura inconsistente de odômetro ou horímetro",
    actionTypes: ["meter_reading_anomaly"],
  },
  {
    id: "fuel_supply_anomaly",
    label: "Abastecimento inconsistente",
    actionTypes: ["fuel_supply_anomaly"],
  },
  {
    id: "stale_meter_reading",
    label: "Odômetro ou horímetro sem variação",
    actionTypes: ["stale_meter_reading"],
  },
  {
    id: "speed_violation",
    label: "Velocidade acima do limite",
    actionTypes: ["speed_violation"],
  },
  {
    id: "harvest_loss_exceeded",
    label: "Perda de colheita acima do limite",
    actionTypes: ["harvest_loss_exceeded"],
  },
  {
    id: "maintenance_overdue",
    label: "Manutenção vencida",
    actionTypes: ["maintenance_overdue"],
  },
];

export function countPendingByCategory(items, categoryId, farmId) {
  const scoped =
    farmId != null
      ? (items || []).filter((item) => String(item.farmId) === String(farmId))
      : items || [];
  if (categoryId === "all") {
    return scoped.length;
  }
  const category = PENDING_ACTION_CATEGORIES.find((row) => row.id === categoryId);
  if (!category || !category.actionTypes) {
    return 0;
  }
  return scoped.filter((item) => category.actionTypes.includes(item.actionType))
    .length;
}

export function filterPendingByCategory(items, categoryId, farmId) {
  const scoped =
    farmId != null
      ? (items || []).filter((item) => String(item.farmId) === String(farmId))
      : items || [];
  if (!categoryId || categoryId === "all") {
    return scoped;
  }
  const category = PENDING_ACTION_CATEGORIES.find((row) => row.id === categoryId);
  if (!category || !category.actionTypes) {
    return scoped;
  }
  return scoped.filter((item) => category.actionTypes.includes(item.actionType));
}

export function resolvePendingCategory(categoryId) {
  return (
    PENDING_ACTION_CATEGORIES.find((row) => row.id === categoryId) ||
    PENDING_ACTION_CATEGORIES[0]
  );
}
